import { useMemo, useRef } from "react";
import type React from "react";
import type { EntitySelectorHandle } from "@salestrak/ui";

// Arrow/Enter keyboard nav for action-picker style EntitySelectors (variable
// picker, add-step picker): focus stays in the search input while arrows move
// the highlighted row and Enter picks it — driven through the selector handle,
// the same idiom the tiptap mention menu uses. Attach `ref` to
// <EntitySelector> and spread `inputProps` onto <EntitySelectorInput>.
export function useSelectorKeyboardNav() {
  const ref = useRef<EntitySelectorHandle>(null);
  const inputProps = useMemo(
    () => ({
      // Arrows would move the caret and Enter would submit an enclosing form,
      // so the nav keys are consumed here.
      onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "ArrowDown") {
          e.preventDefault();
          ref.current?.move(1);
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          ref.current?.move(-1);
        } else if (e.key === "Enter") {
          e.preventDefault();
          ref.current?.selectActive();
        }
      },
    }),
    [],
  );
  return { ref, inputProps };
}
